import React from "react";
import { Input } from "antd";

const FormInput = ({
  name,
  placeholder,
  value,
  onChange,
  maxLength,
  type = "text",
  error,
  className = "",
  disabled,
  readOnly,
  ...rest
}) => {
  return (
    <div style={{ width: "100%" }} data-vendor-field={name}>
      <Input
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        maxLength={maxLength}
        onChange={onChange}
        disabled={disabled}
        readOnly={readOnly}
        className={`w-100 ${error ? "input_error" : ""} ${className}`}
        {...rest}
      />
      {error && <p style={{ color: "red", fontSize: "12px" }}>{error}</p>}
    </div>
  );
};

export default FormInput;
